import { Link } from "react-router-dom";
import CustomButton from "./customButton";
import { useEffect } from "react";
import userOrderUsers from "../store/order/getOrderUser";
import Loader from "./loader";

const CommandeAnnulé = ({t}:any) => {
  const { orderUser, loadingOrderUser, fetchAllOrderUser } = userOrderUsers();

  const selectedStatus = "annulees";

  const filteredOrders = orderUser.filter(
    (order: any) => order.status === selectedStatus
  );

  useEffect(() => {
    fetchAllOrderUser();
     // eslint-disable-next-line 
  }, []);

  console.log("orderUser", orderUser);

  return (
    <div className="border-grey border-[1px] rounded-[5px]">
      {loadingOrderUser ? (
        <Loader />
      ) : filteredOrders.length > 0 ? (
        filteredOrders.map((order: any) => (
          <div key={order.order_id}>
            <div className="bg-softGrey rounded-[5px] py-3 px-5">
              <ul className="w-full flex justify-between">
                <li>
                {t("commande_le")} <br />
                  {new Date(order.created_at).toLocaleDateString()}{" "}
                  {/* Format the date */}
                </li>
                <li>
                  <span className="text-grey text-sm font-normal">
                  {t("produit")}:{" "}
                  </span>
                  <span>{order.products.length}</span>
                </li>
                <li>
                  <span className="text-grey text-sm font-normal">
                  {t("prix_total")}:
                  </span>
                  <br />
                  <span>
                    {parseFloat(order.total_amount).toLocaleString()} F
                  </span>
                </li>
                <li>
                  <span>{t("no_commande")} </span>
                  <br />
                  <span className="text-primary text-sm font-normal">
                    Order #{order.order_id}
                  </span>
                </li>
              </ul>
            </div>

            <div className="py-3 px-5 flex justify-between">
              <div className="flex flex-col gap-4">
                <h3 className="text-[12px] font-normal">
                {t("produit")} ({order.products.length})
                </h3>

                {/* Loop through the products */}
                {order.products.map((product: any, index: number) => (
                  <div className="flex gap-3 items-center" key={index}>
                    <div className="min-h-[60px] max-h-[60px] min-w-[60px] max-w-[60px] rounded-[5px] bg-[#D9D9D9]"></div>
                    <ul className="flex flex-col gap-1 text-[10px] font-normal">
                      <li>{product.product_name}</li>
                      <li>{parseFloat(product.subtotal).toLocaleString()} F</li>
                      <li>{t("quantite")}: {product.quantity} sacs</li>
                    </ul>
                  </div>
                ))}
              </div>
              <div className="flex flex-col gap-2">
                {/*   <CustomButton rounded className="px-4 py-3 bg-primary">
                  <Link className="text-white" to={"/recherche_trans"}>
                    Besoin d’un transporteur
                  </Link>
                </CustomButton> */}
                <CustomButton
                  rounded
                  className="px-4 py-3 border-secondary border-solid border-[1px] transition-all ease-out duration-200 hover:bg-secondary hover:text-white"
                >
                  <Link to={`/details_commandes/${order.order_id}`}>
                  {t("voir_detail_commande")}
                  </Link>
                </CustomButton>
                {/*   <CustomButton rounded className="px-4 py-3 bg-third">
                  <span className="text-black">Faire une réclamation</span>
                </CustomButton> */}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-2xl font-bold flex justify-center">
          {t("commande_annule_non_dispo")} !!!
        </div>
      )}
    </div>
  );
};

export default CommandeAnnulé;
